import { Component, OnInit, Output, EventEmitter, Inject } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";

import { CompanyMasterData } from "src/app/ui/models/domains/pbm/companies/company-master-data";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { CompanyService } from "src/app/ui/services/pbm/company.service";
import { LoadingService } from "src/app/ui/services/loading.service";
import { FiscalNumber } from "src/app/ui/models/domains/pbm/fiscal-number";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "company-master-data-dialog",
  templateUrl: "./company-master-data-dialog.component.html",
  styleUrls: ["./company-master-data-dialog.component.scss"],
})
export class CompanyMasterDataDialogComponent implements OnInit {
  @Output() use: EventEmitter<any> = new EventEmitter();

  fiscalNumberMask = MaskInput.getFicalNumberMask();
  zipCodeMask = MaskInput.getZipCodeMask();

  public companyMasterDataForm: UntypedFormGroup = this.formBuilder.group({
    fiscalNumber: [this.data.getFiscalNumber()],
    corporateName: [this.data.getCorporateName()],
    tradingName: [this.data.getTradingName()],
    type: [this.data.getType()],
    drugFront: [this.data.getDrugFront()],
    situation: [this.data.getSituation()],
    contract: [this.data.getContract()],
    branch: [this.data.getBranch()],
    subBranch: [this.data.getSubBranch()],
    cluster: [this.data.getCluster()],
    street: [this.data.getCompanyInfo().getAddress()[0].getStreet()],
    number: [this.data.getCompanyInfo().getAddress()[0].getNumber()],
    complement: [this.data.getCompanyInfo().getAddress()[0].getComplement()],
    zipCode: [this.data.getCompanyInfo().getAddress()[0].getZipCode()],
    district: [this.data.getCompanyInfo().getAddress()[0].getDistrict()],
    city: [this.data.getCompanyInfo().getAddress()[0].getCity()],
    region: [this.data.getCompanyInfo().getAddress()[0].getState()],
  });

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: CompanyMasterData,
    private companyService: CompanyService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit() {}

  async refreshCompanyMasterData(): Promise<any> {
    const ref = this.loadingService.beginLoading();

    try {
      const fiscalNumer = new FiscalNumber(this.data.getFiscalNumber());
      this.data = await this.companyService.searchCompanyByFicalNumberFromMDM(fiscalNumer);
    } catch (error) {
    } finally {
      this.loadingService.finishLoading(ref);
    }
  }

  close(): void {
    this.dialogRef.close(true);
  }

  useCompanyMasterData(): void {
    this.use.emit(true);
    this.close();
  }
}
